import React, { useEffect, useState } from 'react'
import { useHistory } from "react-router-dom"

import TextField from '@material-ui/core/TextField'
// import InputAdornment from '@material-ui/core/InputAdornment'
// import IconButton from '@material-ui/core/IconButton'
// import Visibility from '@material-ui/icons/Visibility'
// import VisibilityOff from '@material-ui/icons/VisibilityOff'

import CircularProgress from '@material-ui/core/CircularProgress'

import './styles.css'
import { AuthUserContext, withAuthorization } from '../../../contexts/Session'
import Header from '../../../components/Header/Admin/index'
import ConfirmationModal from '../../../components/Modal/Admin/ConfirmDelete/index'
import api from '../../../services/api'

const ListProfiles = (props) => {

    const history = useHistory()
    
    const[name, setName] = useState('')
    const[cpf, setCPF] = useState('')
    const[email, setEmail] = useState('')
    const[password, setPassword] = useState('')

    const[errorName, setErrorName] = useState(false)
    const[errorCPF, setErrorCPF] = useState(false)
    const[errorEmail, setErrorEmail] = useState(false)
    // const[errorPassword, setErrorPassword] = useState(false)
    
    const[errorMessageName, setErrorMessageName] = useState('')
    const[errorMessageCPF, setErrorMessageCPF] = useState('')
    const[errorMessageEmail, setErrorMessageEmail] = useState('')
    // const[errorMessagePass, setErrorMessagePass] = useState('')

    // const[showPassword, setShowPassword] = useState(false)
    const[showConfirmationModal, setShowConfirmationModal] = useState(false)
    const[textModal, setTextModal] = useState('')

    const[disableButton, setDisableButton] = useState(false)

    useEffect(()=>{
        setInterval(() => {
            const value = Math.random().toString(36).substring(2, 10)
            setPassword(value)
            // console.log(value);
        }, 2000)
    },[])

    const handleCreateOuvidoria = () =>{
        
        if(name === ''){
            setErrorName(true)
            setErrorMessageName('Você deve preencher esse campo')
            return
        }else if(cpf === ''){
            setErrorCPF(true)
            setErrorMessageCPF('Você deve preencher esse campo')
            return
        }else if(email === ''){
            setErrorEmail(true)
            setErrorMessageEmail('Você deve preencher esse campo')
            return
        // }else if(password === ''){
        //     // setErrorPassword(true)
        //     // setErrorMessagePass('Você deve preencher esse campo')
        //     return
        }else if(!cpfIsValid(cpf)){
            setErrorCPF(true)
            setErrorMessageCPF('CPF inválido')
            return
        // }else if(password.length < 6){
        //     setErrorPassword(true)
        //     setErrorMessagePass('A senha deve conter mais de 6 dígitos')
        //     return
        }
        else{
            create()
        }

    }

    const handleErrorMessage = (err) =>{
        if(err === 'The email address is improperly formatted.'){
            return 'Email mal formatado!'
        }else if(err === 'The email address is already in use by another account.'){
            return 'Email já cadastrado no sistema!'
        }if(err === 'The password must be a string with at least 6 characters.'){
            return 'Erro ao cadastrar ouvidoria, tente novamente!'
        }else{
            return 'Erro ao cadastrar ouvidoria!'
        }
    } 

    const create = async() =>{
        setDisableButton(true)

        console.log(password);

        const bodyParameters = {
            administrator: false,
            cpf,
            name,
            email,
            password
        }
        
        await api.post(`/admin/create`, bodyParameters,
        {
            headers: {
                authorization: `Bearer ${localStorage.getItem('@Z52InSD4dnfjUDeVSEB0Byy')}`,
            },
        }
        ).then(async(response)=>{
            // console.log(response);

            if(response.status === 200) 
                await handleSendEmail()//calls the funciton that's gonna send the email

            setName('')
            setEmail('')
            setCPF('')
            setPassword('')

        }).catch(error=>{
            // console.log(error.response.data.log.message);
            setDisableButton(false)
            setShowConfirmationModal(true)
            if(error.response.data.log)
                setTextModal(handleErrorMessage(error.response.data.log.message))
            else
                setTextModal('Apenas para administradores')
        })
    }

    const handleSendEmail = async() =>{
        const data = {
            email:email,
            text:`Olá ${name},\nSeu email foi cadastado como Ouvidoria no Aplicativo de Segurança da Mulher!
                Utilize a senha: ${password} para fazer seu login no sistema. Para trocá-la basta acessar a aba Meu Perfil`,
            subject:"Cadastro no Aplicativo de Segurança da Mulher"
        }

        await api.post('/admin/sendEmail', data,
            {
                headers: {
                    authorization: `Bearer ${localStorage.getItem('@Z52InSD4dnfjUDeVSEB0Byy')}`,
                },
            }
        ).then(response=>{

            setDisableButton(false)//stops the circular progress
            setShowConfirmationModal(true)//call the confirmation modal
            setTextModal('Ouvidoria cadastrada com sucesso!')//sets the message

            // console.log(response);
        }).catch(error=>{
            console.log(error);
            setDisableButton(false)
            setShowConfirmationModal(true)
            setTextModal('Erro ao confirmar cadastro de ouvidoria!')
        })
    }
    // const handleErrors = (error) =>{
    //     console.log(error)
    //     if(error.code === 'auth/email-already-in-use'){
    //         setShowConfirmationModal(true)
    //         setTextModal('Email já cadastrado!')

    //     }else if(error.code === 'auth/invalid-email'){
    //         setShowConfirmationModal(true)
    //         setTextModal('Formato de email inválido!')
    //     }
    // }

    const cpfMask = value => {
        return value
          .replace(/\D/g, '') // substitui qualquer caracter que nao seja numero por nada
          .replace(/(\d{3})(\d)/, '$1.$2') // captura 2 grupos de numero o primeiro de 3 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de numero
          .replace(/(\d{3})(\d)/, '$1.$2')
          .replace(/(\d{3})(\d{1,2})/, '$1-$2')
          .replace(/(-\d{2})\d+?$/, '$1') // captura 2 numeros seguidos de um traço e não deixa ser digitado mais nada
    }

    const cpfIsValid = (cpf) => {
        if (typeof cpf !== "string") return false
        cpf = cpf.replace(/[\s.-]*/igm, '')
        if (
            !cpf ||
            cpf.length !== 11 ||
            cpf === "00000000000" ||
            cpf === "11111111111" ||
            cpf === "22222222222" ||
            cpf === "33333333333" ||
            cpf === "44444444444" ||
            cpf === "55555555555" ||
            cpf === "66666666666" ||
            cpf === "77777777777" ||
            cpf === "88888888888" ||
            cpf === "99999999999" 
        ) {
            return false
        }
        var soma = 0
        var resto
        for (var i = 1; i <= 9; i++) 
            soma = soma + parseInt(cpf.substring(i-1, i)) * (11 - i)
        resto = (soma * 10) % 11
        if ((resto === 10) || (resto === 11))  resto = 0
        if (resto !== parseInt(cpf.substring(9, 10)) ) return false
        soma = 0
        for (var j = 1; j <= 10; j++) 
            soma = soma + parseInt(cpf.substring(j-1, j)) * (12 - j)
        resto = (soma * 10) % 11
        if ((resto === 10) || (resto === 11))  resto = 0
        if (resto !== parseInt(cpf.substring(10, 11) ) ) return false
        return true
    }
    
    return(
        <AuthUserContext.Consumer> 
        {authUser =>
            authUser ? 
                <div>
                    <Header/> <br/><br/>
                    <div className='container-create-ouvidoria'>
                        <TextField
                            className='input-login' 
                            id="input-name"
                            label={errorName ? errorMessageName :"Nome completo"} 
                            error={errorName}
                            value={name}
                            fullWidth
                            onChange={event => {
                                setName(event.target.value)
                                setErrorName(false)
                            }} 
                        /> <br/> <br/>

                        <TextField
                            className='input-login' 
                            id="input-cpf"
                            label={errorCPF ? errorMessageCPF :"CPF"} 
                            error={errorCPF}
                            value={cpf}
                            fullWidth
                            onChange={event => {
                                setCPF(cpfMask(event.target.value))
                                setErrorCPF(false)
                            }} 
                        /> <br/> <br/>

                        <TextField
                            className='input-login' 
                            id="input-email"
                            label={errorEmail ? errorMessageEmail :"Email"} 
                            error={errorEmail}
                            value={email}
                            fullWidth
                            onChange={event => {
                                setEmail(event.target.value)
                                setErrorEmail(false)
                            }} 
                        /> <br/> <br/>

                        {/* <TextField
                            className='input-login' 
                            id="input-password"
                            label={errorPassword ? errorMessagePass: 'Senha'}
                            error={errorPassword}
                            type={showPassword ? 'text' : 'password'}
                            value={password}
                            fullWidth
                            InputProps={{
                                endAdornment:(
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={() => setShowPassword(!showPassword)}
                                            onMouseDown={event => event.preventDefault()}
                                            edge="end"
                                        >
                                        {showPassword ? <Visibility /> : <VisibilityOff />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                            onChange={event => {
                                setPassword(event.target.value)
                                setErrorPassword(false)
                            }}
                        /> <br/><br/> */}

                        <button 
                            id ='cadastrar-button'
                            className='modal-header-button' 
                            onClick={handleCreateOuvidoria}
                            disabled={disableButton}
                        >
                            {disableButton?
                                <CircularProgress color='primary' size={15} />:
                                <p className='modal-header-button-text'>CADASTRAR</p>
                            }
                             
                        </button>

                    </div>

                    <ConfirmationModal
                        text={textModal}
                        setShow={setShowConfirmationModal}
                        showModal={showConfirmationModal}
                    />
                </div>

        : 
            history.push('/')
        }
        </AuthUserContext.Consumer>
    )
}

const condition = authUser => !!authUser;

export default withAuthorization(condition)(ListProfiles);